import { createSelector } from "reselect"
import { reducerInit } from "../../api/dbselect.js"

const init = reducerInit("phase", "phaseorder")

export const phaseReducer = (state = init, action) => {
	switch (action.type) {
		case "INSERT_PHASE":
			return [...state, action.response[0]]

		case "UPDATE_PHASE":
			return state.map((object, i) => {
				let newObject = JSON.parse(JSON.stringify(object))
				if (newObject.phaseid === action.id) {
					for (const data in action.json) {
						newObject[data] = action.json[data]
					}
					return newObject
				} else {
					return newObject
				}
			})

		case "DELETE_PHASE":
			return state.filter((object) => object.phaseid !== action.id)

		default:
			return state
	}
}

export const selectPhasesByServicePackageId = createSelector(
	(state, packageId) => state.phaseReducer,
	(_, packageId) => packageId,
	(phases, packageId) => {
		return phases.filter((phase) => packageId === phase.servicepackageid)
	}
)
